export default {
    contactReadAllBegin(state) {
        state.loading = true;
    },

    contactReadAllSuccess(state, data) {
        state.loading = false;
        state.data = data.list;
        state.total = data.total ? data.total : 0;
        state.initialData = state.data;
    },

    contactReadAllErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    contactReadBegin(state) {
        state.loading = true;
    },

    contactReadSuccess(state, data) {
        state.loading = false;
        state.data = data;
        state.initialData = state.data;
    },

    contactReadErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    contactAddBegin(state) {
        state.loading = true;
    },

    contactAddSuccess(state) {
        state.loading = false;
    },

    contactAddErr(state, err) {
        state.loading = false;
        state.error = err;
    },

    contactUpdateBegin(state) {
        state.loading = true;
    },

    contactUpdateSuccess(state, data) {
        const index = state.data.findIndex((contact) => contact.id === data.id);
        state.data[index] = data;
        state.loading = false;
    },

    contactUpdateErr(state, err) {
        state.loading = false;
        state.error = err;
    },
};